import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import palette from "../../../styles/palette";
import { RETRY_OR_RESET, RETRY } from "../../../../constants/strings";
import Button from "../../../Button";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    textAlign: "center",
  },
  text: {
    fontSize: "0.875rem",
    color: palette.typography.black.solid,
    fontWeight: "normal",
    letterSpacing: "-0.02em",
    lineHeight: "1.25rem",
  },
  button: {
    marginTop: "1.25rem",
    padding: "0.3125rem 0.625rem",
    color: palette.typography.black.high,
    backgroundColor: palette.typography.white.solid,
    fontSize: "0.875rem",
    border: `1px solid ${palette.typography.black.medium}`,
  },
}));

const RetryErrorComponent = ({
  onRetryClick,
  errorText,
  isRetryEnabled,
  isRouteDefault,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography className={classes.text}>{errorText}</Typography>
      {isRetryEnabled && !isRouteDefault && (
        <>
          <Typography className={classes.text}>{RETRY_OR_RESET}</Typography>
          <Button onClick={onRetryClick} className={classes.button}>
            {RETRY}
          </Button>
        </>
      )}
    </Box>
  );
};

export default RetryErrorComponent;
